import React from "react";
import { Link, NavLink } from "react-router-dom";
import { MARKETING } from "@/constants/testIds";

export default function MarketingNav() {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-stone-200 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8">
        <Link to="/" data-testid={MARKETING.navHome} className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-md bg-slate-950 text-white">
            <span className="font-display text-sm font-bold">A</span>
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-display text-lg font-bold tracking-tight text-slate-950">ATLAS™</span>
            <span className="label-mono !text-[8px] !tracking-[0.24em] leading-none">The IXL Business Pro</span>
          </div>
        </Link>
        <nav className="hidden items-center gap-1 md:flex">
          <a href="/#product" data-testid={MARKETING.navProduct} className="btn-ghost">Product</a>
          <a href="/#pricing" data-testid={MARKETING.navPricing} className="btn-ghost">Pricing</a>
          <NavLink to="/capital-raising" data-testid={MARKETING.navCapital} className="btn-ghost">Capital Raising</NavLink>
          <a href="/#outcomes" className="btn-ghost">Outcomes</a>
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/login" data-testid={MARKETING.navLogin} className="btn-ghost">Sign in</Link>
          <Link to="/request-demo" data-testid={MARKETING.navSignup} className="btn-primary !px-4 !py-2 !text-sm">
            Request Demo
          </Link>
        </div>
      </div>
    </header>
  );
}
